import React from "react";
import { Style } from "./style";
import { FooterViewProps } from "./type";
import { langText } from "../../../recoil/lang";

const FooterView = ({ props, hook }: FooterViewProps) => {
  return (
    <Style>
      {hook.interphoneCheck() ? (
        <div className="footerWrap">
          {hook.interphoneCheck() && (
            <div className="request">
              {/* 부재중 확인 */}
              {hook.missedCallList && hook.missedCallList.length > 0 && (
                <>
                  {hook.isOpenDetail ? (
                    <div className={`missedCallWrap`}>
                      <div className="header">
                        <h2>
                          {langText.missed_call[hook.lang]}{" "}
                          {hook.missedCallList.length}
                          {langText.items[hook.lang]}
                        </h2>
                        <button
                          className="delete"
                          onClick={() => hook.checkUnavailableCall()}
                        >
                          {langText.clear[hook.lang]}&ensp;&#10005;
                        </button>
                      </div>
                      <div className="listWrap">
                        {hook.missedCallList.map((item) => (
                          <div key={item.manage_id} className="callItemWrap">
                            <h3>{item.sender_name}</h3>
                            <button onClick={() => hook.requestVoiceChat(item)}>
                              <img
                                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_phone.svg`}
                                alt="phone"
                              />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <button className="cntButton" onClick={hook.openMissedCall}>
                      {langText.missed_call[hook.lang]}{" "}
                      {hook.missedCallList.length}
                      {langText.items[hook.lang]}
                    </button>
                  )}
                </>
              )}
              {/* 인터폰 버튼 */}

              <button
                className="buttonWrap"
                onClick={hook.handleInterphoneClick}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_interphone.svg`}
                  alt="interphone"
                />
                {langText.interphone[hook.lang]}
              </button>
            </div>
          )}
          {hook.interphoneCheck() && hook.conciergeCheck() && (
            <div className="divider" />
          )}
          {/* 컨시어지 버튼 */}
          {hook.conciergeCheck() && (
            <div className="request">
              {hook.newChatListFlag.length > 0 && (
                <div className="cntButton">
                  {langText.new_msg[hook.lang]} {hook.newChatListFlag.length}
                  {langText.items[hook.lang]}
                </div>
              )}
              <button
                className="buttonWrap"
                onClick={hook.handleConciergeClick}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_chat.svg`}
                  alt="chat"
                />
                {langText.conciergeModal_button_submit[hook.lang]}
              </button>
            </div>
          )}
        </div>
      ) : (
        <div />
      )}
    </Style>
  );
};
export default FooterView;
